import { Component, OnInit } from '@angular/core';
import { AdminReportService } from '../../services/admin-report.service';
import { PlayroomService } from '../../services/playroom.service';
import { Playroom } from '../../models/playroom.model';

@Component({
  selector: 'app-doplatne-karte-report',
  templateUrl: './doplatne-karte-report.component.html',
  styleUrls: ['./doplatne-karte-report.component.scss']
})
export class DoplatneKarteReportComponent implements OnInit {
  rooms: Playroom[] = [];
  selectedRoomName: string | null = null;
  dateFrom = '';
  dateTo = '';

  report: any = null;
  loading = false;

  activeRoomName = '';
  activeDateFrom = '';
  activeDateTo = '';

  constructor(
    private reportService: AdminReportService,
    private playroomService: PlayroomService
  ) {}

  ngOnInit(): void {
    this.playroomService.getAllPlayroomsSub().subscribe(data => {
      this.rooms = data || [];
    });
    this.loadSearchResult();
  }

  loadSearchResult() {
    this.loading = true;
    this.reportService.getSurchargeTicketsReport({
      roomName: this.selectedRoomName,
      dateFrom: this.dateFrom || null,
      dateTo: this.dateTo || null
    }).subscribe({
      next: (data) => {
        this.report = data;
        this.activeRoomName = this.selectedRoomName || 'Sve igraonice';
        this.activeDateFrom = this.dateFrom;
        this.activeDateTo = this.dateTo;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  resetFilters() {
    this.selectedRoomName = null;
    this.dateFrom = '';
    this.dateTo = '';
    this.loadSearchResult();
  }

  exportCsv() {
    if (!this.report) { return; }

    const roomName = this.selectedRoomName ?? 'Sve igraonice';

    const periodFrom = this.dateFrom ? this.formatDate(this.dateFrom) : '/';
    const periodTo = this.dateTo ? this.formatDate(this.dateTo) : '/';

    const rows: string[] = [];
    rows.push([
      'Igraonica', 'Period od', 'Period do',
      'Ukupan broj karata', 'Ukupan broj sati', 'Broj doplatnih sati',
      'Broj gratis karti', 'Broj paket karata'
    ].map(v => this.escapeCsv(v)).join(','));

    rows.push([
      roomName, periodFrom, periodTo,
      String(this.report.totalTickets ?? 0),
      String(this.report.totalHours ?? 0),
      String(this.report.totalSurchargeHours ?? 0),
      String(this.report.totalGratisTickets ?? 0),
      String(this.report.totalPackageTickets ?? 0)
    ].map(v => this.escapeCsv(v)).join(','));

    const csvContent = '\uFEFF' + rows.join('\n');
    this.blobToFile(csvContent, 'text/csv;charset=utf-8;', 'DoplatneKarte.csv');
  }

  private escapeCsv(value: string): string {
    return `"${String(value ?? '').replace(/"/g, '""')}"`;
  }

  private formatDate(value: string | Date): string {
    if (!value) { return ''; }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) { return ''; }
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}.`;
  }

  private blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
